import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

interface IProps {
    className?: string;
    style?: any;
}

export const ImageCarousel: React.FunctionComponent<IProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 64 64" {...props}>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g>
                    <rect x="0" y="0" width="64" height="64"></rect>
                    <g transform="translate(16.000000, 12.000000)">
                        <rect fillRule="nonzero" x="0" y="0" width="32" height="32"></rect>
                        <circle stroke="currentColor" strokeWidth="2" cx="24" cy="8" r="4"></circle>
                        <polygon
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinejoin="round"
                            points="4 27 12 12 17.3333333 21.5454545 22.6666667 18.8181818 28 27"
                        ></polygon>
                    </g>
                    <g transform="translate(22.000000, 52.000000)" stroke="currentColor" strokeWidth="2">
                        <circle cx="10" cy="2" r="2"></circle>
                        <circle cx="2" cy="2" r="2"></circle>
                        <circle cx="18" cy="2" r="2"></circle>
                    </g>
                    <g transform="translate(7.000000, 32.000000) rotate(90.000000) translate(-7.000000, -32.000000) translate(0.000000, 25.000000)">
                        <rect x="0" y="0" width="14" height="14"></rect>
                        <polyline
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            transform="translate(7.000000, 7.000000) rotate(270.000000) translate(-7.000000, -7.000000) "
                            points="9 11 5 7 9 3"
                        ></polyline>
                    </g>
                    <g transform="translate(57.000000, 32.000000) rotate(270.000000) translate(-57.000000, -32.000000) translate(50.000000, 25.000000)">
                        <rect x="0" y="0" width="14" height="14"></rect>
                        <polyline
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            transform="translate(7.000000, 7.000000) rotate(270.000000) translate(-7.000000, -7.000000) "
                            points="9 11 5 7 9 3"
                        ></polyline>
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};
